// Module
var code = "<div class=\"row\"> <div class=\"col-md-8 col-md-offset-2\"> <h2 data-bind=\"restext: 'PasswordResetProcessChanged'\"></h2> <p data-bind=\"restext: 'PasswordResetProcessMessage'\"></p> <p data-bind=\"restext: 'PasswordResetProcessInstructions'\"></p> </div> </div> ";
// Exports
export default code;